"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/faqSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FaqSectionAccordionActivesItem = {
    key: Key | null | undefined;
    /** Detected variants: "accordion-item active" | "accordion-item" */
    className: string;
    /** Detected variants: "accordion-collapse collapse show" | "accordion-collapse collapse" */
    div0ClassName: string;
    /** Detected variants: "Our skincare specialists analyze your skin type, concerns, and goals before recommending the most suitable treatment for safe and effective results." | "Yes, we offer customized treatments specially designed for sensitive skin using gentle, dermatologist-approved products and techniques." | "Results vary depending on the treatment and skin condition. Some treatments show immediate results, while others may require multiple sessions." | "Yes, we recommend a consultation to understand your skin concerns and create a personalized treatment plan." | "Yes, all our skincare specialists are trained, experienced, and certified to provide safe and professional skincare treatments." | "Most treatments have minimal or no downtime. However, some advanced treatments may require short recovery periods." */
    p0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" | "collapseSix" */
    id: string;
    /** Detected variants: "headingOne" | "headingTwo" | "headingThree" | "headingFour" | "headingFive" | "headingSix" */
    h30Id: string;
    /** Detected variants: "How do I know which skincare treatment is right for me?" | "Are skincare treatments safe for sensitive skin?" | "How many sessions are needed to see results?" | "Do I need a consultation before booking a treatment?" | "Are your skincare specialists certified professionals?" | "Is there any downtime after skincare treatments?" */
    link0Text: ReactNode;
    /** Detected variants: "collapseOne" | "collapseTwo" | "collapseThree" | "collapseFour" | "collapseFive" | "collapseSix" */
    ariaControls: string;
    /** Detected variants: "true" | "false" */
    ariaExpanded: boolean;
    /** Detected variants: "accordion-button" | "accordion-button collapsed" */
    link0ClassName: string;
    /** Detected variants: "#collapseOne" | "#collapseTwo" | "#collapseThree" | "#collapseFour" | "#collapseFive" | "#collapseSix" */
    dataBsTarget: string;
    /** Detected variants: "#faq-details-one" */
    dataBsParent?: string;
    /** Detected variants: "accordion-body" */
    div0ClassName2?: string;
    /** Detected variants: "accordion-content" */
    div0ClassName3?: string;
    /** Detected variants: "accordion-header" */
    h30ClassName?: string;
    /** Detected variants: "collapse" */
    dataBsToggle?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeFourteenFaqSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionActivesItem) => Partial<ComponentProps<"h3">>);
    divH30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionActivesItem) => Partial<ComponentProps<typeof SmartLink>>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "Most" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Dermatology" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Questions?" */
    sectionDiv0Div0Div0Div0H20Span1SpanText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "faq-details-one" */
    sectionDiv0Div0Div1Div0Div0DivId?: string;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/faq-bg-02.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    faqSectionAccordionActives: FaqSectionAccordionActivesItem[];
    faqSectionAccordionActivesItemWrapper?: (item: FaqSectionAccordionActivesItem, content: ReactNode) => ReactNode;
    faqSectionAccordionActivesRenderer?: (defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionActivesLinkVisible?: boolean;
    faqSectionAccordionActivesLinkRenderer?: (item: FaqSectionAccordionActivesItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionActivesH3Visible?: boolean;
    faqSectionAccordionActivesH3Renderer?: (item: FaqSectionAccordionActivesItem, defaultNode: ReactNode) => ReactNode;
    faqSectionAccordionActivesLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FaqSectionAccordionActivesItem) => Partial<ComponentProps<typeof SmartLink>>);
    faqSectionAccordionActivesH3Props?: Partial<ComponentProps<"h3">> | ((item: FaqSectionAccordionActivesItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourteenFaqSectionGenerated: FC<HomeFourteenFaqSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0H20H2Text = "Most",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "Dermatology",
    sectionDiv0Div0Div0Div0H20Span1SpanText = "Questions?",
    sectionDiv0Div0Div1Div0Div0DivId = "faq-details-one",
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/faq-bg-02.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divH30H3Props,
    divH30Link0LinkProps,
    sectionDiv0Div0ClassName,
    faqSectionAccordionActives,
    faqSectionAccordionActivesItemWrapper,
    faqSectionAccordionActivesRenderer,
    faqSectionAccordionActivesLinkVisible,
    faqSectionAccordionActivesLinkRenderer,
    faqSectionAccordionActivesH3Visible,
    faqSectionAccordionActivesH3Renderer,
    faqSectionAccordionActivesLinkProps,
    faqSectionAccordionActivesH3Props,
}) => {
    return (
        <section className="faq-section-fourteen section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-6">
                        <div className="section-header section-header-fourteen">
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    <span className="section-line">{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                    {" "}
                                    <span className="subtitle">{sectionDiv0Div0Div0Div0H20Span1SpanText}</span>
                                </h2>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="faq-info faq-info-fourteen wow zoomIn" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                            <div className="accordion" id={sectionDiv0Div0Div1Div0Div0DivId}>
                                {renderCollectionNode(
                                    faqSectionAccordionActives,
                                    (item: FaqSectionAccordionActivesItem) => (
                                        <div className={item.className} key={item.key}>
                                            {renderItemNode(faqSectionAccordionActivesH3Visible, faqSectionAccordionActivesH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "accordion-header"} id={item.h30Id} {...(typeof faqSectionAccordionActivesH3Props === "function" ? faqSectionAccordionActivesH3Props(item) : (faqSectionAccordionActivesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                    {renderItemNode(faqSectionAccordionActivesLinkVisible, faqSectionAccordionActivesLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} className={item.link0ClassName} data-bs-toggle={item.dataBsToggle ?? "collapse"} data-bs-target={item.dataBsTarget} aria-expanded={item.ariaExpanded} aria-controls={item.ariaControls} {...(typeof faqSectionAccordionActivesLinkProps === "function" ? faqSectionAccordionActivesLinkProps(item) : (faqSectionAccordionActivesLinkProps ?? {}))} {...(typeof divH30Link0LinkProps === "function" ? divH30Link0LinkProps(item) : (divH30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                    ))}
                                                </h3>
                                            ))}
                                            <div id={item.id} className={item.div0ClassName} data-bs-parent={item.dataBsParent ?? "#faq-details-one"}>
                                                <div className={item.div0ClassName2 ?? "accordion-body"}>
                                                    <div className={item.div0ClassName3 ?? "accordion-content"}>
                                                        <p>{item.p0Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    faqSectionAccordionActivesItemWrapper,
                                    faqSectionAccordionActivesRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="faq-bg img-fluid" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFourteenFaqSectionGenerated;
